import React from 'react'
import { Modal, ModalBody, Label, Input, ModalFooter, Button } from 'reactstrap'
import { connect } from 'react-redux'
import intl from 'react-intl-universal'

import { getDropCaps, applyDropcaps } from '~/redux/settingsReducer'
import { EllipsisReduxStore } from '~/types'

interface StoreProps {
  dropCaps: EllipsisReduxStore['settings']['dropCaps']
  applyDropcaps: (boolean) => void
}

export interface Props {
  toggle: () => void
}

function ToolboxTextSettings(props: Props & StoreProps) {
  const { toggle, applyDropcaps, dropCaps } = props
  return (
    <Modal
      wrapClassName="bootstrap4"
      size="lg"
      centered
      isOpen={true}
      toggle={toggle}
    >
      <ModalBody className="m-3">
        <h4>{intl.get('ToolboxTextSettingsModal.modal.header')}</h4>
        <Label check>
          <Input
            data-testid="dropcaps-checkbox"
            type="checkbox"
            checked={dropCaps}
            onChange={(event) => applyDropcaps(event.target.checked)}
          />
          {intl.get('ToolboxTextSettingsModal.dropcaps.label')}
        </Label>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" outline onClick={toggle}>
          {intl.get('ToolboxTextSettingsModal.modal.close')}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

const mapDispatchToProps = (dispatch) => ({
  applyDropcaps: (dropcapsEnabled: boolean) =>
    dispatch(applyDropcaps(dropcapsEnabled)),
})

export default connect(
  (state: EllipsisReduxStore) => ({
    dropCaps: getDropCaps(state),
  }),
  mapDispatchToProps
)(ToolboxTextSettings)
